import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { RecoverPasswordRepository } from '../repositories/recover-password.repository';

@Injectable({
  providedIn: 'root'
})
export class RecoverPasswordService {

  constructor(
    private recoverPasswordRepository: RecoverPasswordRepository
  ) { }

  public recoverPassword(recoverForm: any, token: string): Observable<any> {
    return this.recoverPasswordRepository.recoverPassword(recoverForm, token);
  }

  public changePassword(formChangePassword: any): Observable<any> {
    return this.recoverPasswordRepository.changePassword(formChangePassword);
  }

}
